import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import LandingPage from "./LandingPage/Pages";
import DonasiUmumPage from "./LandingPage/Pages/donasiUmumPage/donasiUmumPage";
import DetailDonasiPage from "./LandingPage/Pages/donasiUmumPage/detailDonasiPage";
import DonatePage from "./LandingPage/Pages/donasiUmumPage/DonatePage";
import PaymentReceiptPage from "./LandingPage/Pages/donasiUmumPage/PaymentReceiptPage";
import BeritaPage from "./LandingPage/Pages/news/newsPage";
import DetailBeritaPage from "./LandingPage/Pages/news/DetailBeritaPage";
import RelawanRegisterPage from "./LandingPage/Pages/relawan/RelawanRegisterPage";

declare global {
  interface Window {
    fbq: any;
  }
}

// ─────────────────────────────────────────
// META PIXEL PAGE VIEW TRACKER
// Dipanggil setiap kali route berubah
// ─────────────────────────────────────────
const PixelTracker = () => {
  const location = useLocation();

  useEffect(() => {
    if (!window.fbq) return;

    window.fbq("track", "PageView");

    if (process.env.NODE_ENV === "development") {
      console.log("[Meta Pixel] PageView →", location.pathname);
    }
  }, [location.pathname]); // ← pakai .pathname bukan location object langsung

  return null;
};

// ─────────────────────────────────────────
// APP
// ─────────────────────────────────────────
const App = () => {
  return (
    <Router>
      <PixelTracker />
      <Routes>
        {/* HOME */}
        <Route path="/" element={<LandingPage />} />

        {/* DONASI */}
        <Route path="/donasi" element={<DonasiUmumPage />} />
        <Route path="/donasi/:slug" element={<DetailDonasiPage />} />
        <Route path="/donate/:slug/:campaignId" element={<DonatePage />} />
        <Route path="/payment/:donationId" element={<PaymentReceiptPage />} />

        {/* BERITA */}
        <Route path="/berita" element={<BeritaPage />} />
        <Route path="/berita/:slug" element={<DetailBeritaPage />} />

        {/* RELAWAN */}
        <Route path="/relawan" element={<RelawanRegisterPage />} />
      </Routes>
    </Router>
  );
};

export default App;
